@if (subscription?.data) {
    <div class="has-text-left-desktop has-text-centered">
        <!-- FAI -->
        @if (!isFaimUnlimited) {
            <div>
                <!-- Range -->
                <h3 class="title is-level-4 has-text-left">
                    <span>{{ subscription.data.short_description }}</span>
                </h3>
                <!-- Plays -->
                <div class="mt-1 columns is-mobile">
                    <div class="column is-narrow is-paddingless">
                        <span class="icon is-huge is-info align-start"><i class="tri-box" aria-hidden="true"></i></span>
                    </div>
                    <div class="column has-text-left">
                        <ng-container
                            *ngTemplateOutlet="priceTemplate; context: { subscription: subscription }"
                        ></ng-container>
                        <p class="text is-level-3 mt-1">
                            <span>{{ subscription | playsLabel }}</span>
                        </p>
                        <!-- Obligation -->
                        @if (veryHighSpeed) {
                            <p class="text is-level-3">Très haut débit FTTH</p>
                        }
                        <!-- Data -->
                        @if (dataEnvelope) {
                            <p class="is-size-3 has-text-weight-semibold is-marginless">
                                {{ dataEnvelope }}
                            </p>
                        }
                        <p class="range-label text is-level-3" ng-if="isCustomDebit">
                            <span class="is-block is-paddingless is-marginless">
                                <span>Débit descendant jusqu'à</span>
                                {{ speedDownLabel }}
                            </span>
                            <span class="is-block">
                                <span>Débit montant jusqu'à</span>
                                {{ speedUpLabel }}
                            </span>
                        </p>
                        @if (showHighSpeedOption) {
                            <checkout-debit-plus-block />
                        }
                        <!-- Prix -->
                    </div>
                </div>
            </div>
            <!-- BTv -->
            @if (subscription | isSmartTV) {
                <div>
                    <div class="services-list columns is-marginless is-mobile is-aligned-center">
                        <div class="column is-narrow is-paddingless">
                            <span class="icon is-huge"><i class="tri-tv-btv"></i></span>
                        </div>
                        <div class="column is-paddingless">
                            <p class="is-size-6 has-text-left">
                                Vos chaines tv avec B.tv
                                <ng-container>+</ng-container>
                            </p>
                        </div>
                    </div>
                </div>
            }
        } @else {
            <!-- 4GBOX or 5GBOX-->
            <div class="block-element">
                @if (isTerebiOffer) {
                    <div class="img-container">
                        <img alt="Logo offre 5G Box avec TV" src="assets/checkout/terebi_offer_logo.svg" />
                    </div>
                    <p class="text is-level-1 is-marginless mb-2">
                        <span>Internet et TV</span>
                    </p>
                } @else {
                    <h3 class="title has-text-tertiary has-text-weight-semibold is-capitalized is-level-2 mt-2">
                        {{ subscription?.technology | equipmentLabel }}
                    </h3>
                }
                <div
                    class="columns is-aligned-center is-marginless is-justified-center is-justified-start-desktop is-mobile"
                >
                    <div class="column is-narrow is-paddingless">
                        <span class="icon is-huge is-info">
                            <i class="tri-box-4g"></i>
                        </span>
                    </div>
                    <div class="column is-narrow">
                        <ng-container
                            *ngTemplateOutlet="priceTemplate; context: { subscription: subscription }"
                        ></ng-container>
                    </div>
                </div>
            </div>
        }
        <div class="divider has-background-info-fade"></div>
        <!-- Adresse -->
        <div class="columns is-mobile address-infos is-fullwidth is-aligned-center">
            <div class="column is-narrow is-paddingless">
                <span class="icon is-medium"><i class="tri-marker"></i></span>
            </div>
            <div class="column has-text-left">
                <p checkoutCy="install_address">
                    <span class="is-block has-text-weight-semibold is-size-6">Adresse d'installation</span>
                    <span
                        checkoutCsMask
                        checkoutCy="install_address_text"
                        class="is-block paragraph text is-level-2 is-marginless"
                    >
                        {{ userAddress }}
                    </span>
                </p>
            </div>
            @if (isFtth3Clics) {
                <div checkoutCy="ftth3clics-edit" class="has-text-right column is-2">
                    <a class="link has-text-tertiary is-size-7" (click)="goToWall()">Modifier</a>
                </div>
            }
        </div>
    </div>
}
<ng-template #priceTemplate let-subscription="subscription">
    <div>
        <div>
            <trg-price
                [hasPeriod]="true"
                [price]="subscription?.prices?.final + subscription.data?.rental_fees"
                [isInlined]="false"
                class="is-margin"
                size="has-text-weight-bold is-size-3"
            />
        </div>

        @if (promoHome) {
            <span class="sticker is-small mt-1 mb-1">
                {{ promoHome.fanion || '-{{ promoHome.amount  }}€/mois déjà déduit' }}
            </span>
        }

        @if (subscription?.prices?.duration) {
            <p class="text is-level-3 is-marginless">
                Pendant
                <span>{{ subscription?.prices?.duration }}</span>
                mois puis
                @if (subscription?.prices?.base) {
                    <trg-price
                        [price]="(subscription | priceInitial) + subscription.data?.rental_fees"
                        [isInlined]="true"
                        [inheritFontSize]="true"
                    />
                }
            </p>
        }

        <p class="text is-level-3 is-marginless">
            {{ isFaimUnlimited ? 'Sans engagement' : (subscription?.data?.obligation | obligationLabel: false : true) }}
        </p>
    </div>
</ng-template>
